import { render, staticRenderFns } from "./ShopSetting.vue?vue&type=template&id=55ac72a0&scoped=true&"
import script from "./ShopSetting.vue?vue&type=script&lang=js&"
export * from "./ShopSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopSetting.vue?vue&type=style&index=0&id=55ac72a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac72a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ac72a0')) {
      api.createRecord('55ac72a0', component.options)
    } else {
      api.reload('55ac72a0', component.options)
    }
    module.hot.accept("./ShopSetting.vue?vue&type=template&id=55ac72a0&scoped=true&", function () {
      api.rerender('55ac72a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/SettingChildred/ShopSetting.vue"
export default component.exports